import { render, staticRenderFns } from "./Tiyou.vue?vue&type=template&id=3f523154&scoped=true&"
import script from "./Tiyou.vue?vue&type=script&lang=js&"
export * from "./Tiyou.vue?vue&type=script&lang=js&"
import style0 from "./Tiyou.vue?vue&type=style&index=0&id=3f523154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f523154",
  null
  
)

export default component.exports